import Vue from 'vue'
import Router from 'vue-router'
import FooterTab from "@/views/Index/footerTab"; // 底部切换
import Index from "@/views/Index/index"; // 首页
import selectVisitor from "@/views/Index/selectVisitor"; // 挂号选择就诊人
import RegRecordDetail from "@/views/Index/RegRecordDetail"; // 订单详情
import PHRAccessAuthorize from "@/views/Index/PHRAccessAuthorize"; // 健康档案调阅授权
import User from "@/views/user/user"; // 用户页面
import gotogzh from "@/views/user/gotogzh"; // 中心要闻
import appointmentVaccines from "@/views/user/appointmentVaccines"; // 疫苗预约
import jiushiwan from "@/views/user/jiushiwan"; // 小飞棍来喽
import CollegesDepartments from "@/views/HospitalInformation/CollegesDepartments"; // 来院导航
import NavigationSelectionYq from "@/views/HospitalInformation/NavigationSelectionYq"; // 来院导航
import AddVisitors from "@/views/EstablishArchives/AddVisitors"; // 建档
import MedicalCard from "@/views/EstablishArchives/MedicalCard"; // 电子健康卡
import MessagePush from "@/views/HospitalInformation/MessagePush"; // 新闻动态
import HealthEducation from "@/views/HospitalInformation/HealthEducation"; // 健康宣教
import HospitalNavigation from "@/views/Index/website/HospitalNavigation/HospitalNavigation"; // 选择院区
import buildingSelect from "@/views/Index/website/HospitalNavigation/buildingSelect"; // 选择大楼
import BuildingInformation from "@/views/Index/website/HospitalNavigation/BuildingInformation"; // 楼层科室分布
import YardBrief from "@/views/Index/website/YardBrief/YardBrief"; // 院区列表
import YardDetails from "@/views/Index/website/YardBrief/YardDetails"; // 院区详情
import experts from "@/views/Index/website/experts/experts"; // 专家骨干
import doctorDetails from "@/views/Index/website/experts/doctorDetails"; // 专家简介
import hospitalRegister from "@/views/Index/hospitalRegister"; // 就诊院区选择
import DepartmentSelection from "@/views/Index/DepartmentSelection"; // 科室选择
import ChooseDoctor from "@/views/Index/ChooseDoctor"; // 选医生
import ChooseTime from "@/views/Index/ChooseTime"; // 选时间
import AppointmentDetails from "@/views/Index/AppointmentDetails"; // 就诊信息确认
import HospitalProfile from "@/views/Index/website/HospitalProfile"; // 医院简介
import KeyDepartments from "@/views/Index/website/KeyDepartments"; // 重点科室
import DepartmentDoctor from "@/views/Index/website/DepartmentDoctor"; // 科室中选医生
import DepartmentDetails from "@/views/Index/website/DepartmentDetails"; // 科室详情
import website from "@/views/Index/website/website"; // 微官网
import HealthCard from "@/views/Index/HealthCard"; // 电子健康卡
import PriceInquiry from "@/views/Index/PriceInquiry"; // 物价查询
import nucleicTest from "@/views/Index/nucleicTest"; // 核酸号源
import payment from "@/views/Index/payment"; // 支付
import countDown from "@/views/Index/countDown"; // 支付倒计时
import outpatientDepartment from "@/views/Index/outpatientDepartment"; // 支付倒计时
import mySubscribe from "@/views/Index/mySubscribe"; // 我的预约
import paymentRecord from "@/views/Index/paymentRecord"; // 缴费记录
import paymentRecordDetails from "@/views/Index/paymentRecordDetails"; // 缴费记录详细
import Service from "@/views/Service/Service"; // 住院服务
import GeneralList from "@/views/Service/GeneralList"; // 住院信息
import questionnaire from "@/views/Index/questionnaire/questionnaire"; // 问卷列表
import questionnaireList from "@/views/Index/questionnaire/questionnaireList"; // 满意度调查
import Report from "@/views/Index/Report/report"; // 报告查询
import textReportetails from "@/views/Index/Report/textReportetails"; // 检验报告
import screenReportetails from "@/views/Index/Report/screenReportetails"; // 检查报告
import OutpatientDeposit from "@/views/Index/Deposit/OutpatientDeposit"; // 住院押金充值
import Recharge from "@/views/Index/Deposit/Recharge"; // 押金充值
import RechargeRecord from "@/views/Index/Deposit/RechargeRecord"; // 充值记录

Vue.use(Router)
const originalPush = Router.prototype.push
   Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/index",
      component: FooterTab,
      children: [{
        path: "index",
        component: Index,
        meta: {
          keepAlive: true // 需要缓存
        }
      },
      {
        path: "user",
        component: User,
        meta: {
          title: " 个人中心"
        }
      }]
    },
    {
      path: "/jiushiwan",
      component: jiushiwan,
      meta: {
        title: "小飞棍来喽"
      }
    },
    {
      path: "/selectVisitor",
      component: selectVisitor,
      meta: {
        title: "选择就诊人"
      }
    },
    {
      path: "/RegRecordDetail",
      component: RegRecordDetail,
      meta: {
        title: "订单详情"
      }
    },
    {
      path: "/PHRAccessAuthorize",
      component: PHRAccessAuthorize,
      meta: {
        title: "健康档案调阅授权"
      }
    },
    {
      path: "/NavigationSelectionYq",
      component: NavigationSelectionYq,
      meta: {
        title: "来院导航"
      }
    },
    {
      path: "/collegesdepartments",
      component: CollegesDepartments,
      meta: {
        title: "来院导航"
      }
    },
    {
      path: "/MedicalCard",
      component: MedicalCard,
      meta: {
        title: "电子健康卡"
      }
    },
    {
      path: "/MessagePush",
      component: MessagePush,
      meta: {
        title: "新闻动态"
      }
    },
    {
      path: "/HealthEducation",
      component: HealthEducation,
      meta: {
        title: "健康宣教"
      }
    },
    {
      path: "/addVisitors",
      component: AddVisitors,
      meta: {
        title: "注册电子健康卡"
      }
    },
    {
      path: "/HospitalNavigation",
      component: HospitalNavigation,
      meta: {
        title: "选择院区"
      }
    },
    {
      path: "/HospitalNavigation/buildingSelect",
      component: buildingSelect
    },
    {
      path: "/HospitalNavigation/BuildingInformation",
      component: BuildingInformation
    },
    {
      path: "/hospitalRegister",
      component: hospitalRegister,
      meta: {
        title: "就诊院区选择"
      }
    },
    {
      path: "/DepartmentSelection",
      component: DepartmentSelection,
      meta: {
        title: "科室选择",
        // keepAlive: true // 需要缓存
      }
    },
    {
      path: "/ChooseDoctor",
      component: ChooseDoctor,
      meta: {
        title: "选择就诊医生",
        keepAlive: true // 需要缓存
      }
    },
    {
      path: "/ChooseTime",
      component: ChooseTime,
      meta: {
        title: "选择就诊日期",
        // keepAlive: true // 需要缓存
      }
    },
    {
      path: "/AppointmentDetails",
      component: AppointmentDetails,
      meta: {
        title: "就诊信息确认"
      }
    },
    {
      path: "/HospitalProfile",
      component: HospitalProfile,
      meta: {
        title: "医院简介"
      }
    },
    {
      path: "/KeyDepartments",
      component: KeyDepartments,
      meta: {
        title: "重点科室"
      }
    },
    {
      path: "/DepartmentDoctor",
      component: DepartmentDoctor,
      meta: {
        title: "科室名称"
      }
    },
    {
      path: "/DepartmentDetails",
      component: DepartmentDetails,
      meta: {
        title: "科室详情"
      }
    },
    {
      path: "/YardBrief",
      component: YardBrief,
      meta: {
        title: "院区列表"
      }
    },
    {
      path: "/YardBrief/YardDetails",
      component: YardDetails,
      meta: {
        title: "院区详情"
      }
    },
    {
      path: "/experts",
      component: experts,
      meta: {
        title: "专家骨干",
        keepAlive: true // 需要缓存
      }
    },
    {
      path: "/experts/doctorDetails",
      component: doctorDetails,
      meta: {
        title: "专家骨干"
      }
    },
    {
      path: "/website",
      component: website,
      meta: {
        title: "微官网"
      }
    },
    {
      path: "/HealthCard",
      component: HealthCard,
      meta: {
        title: "电子健康卡"
      }
    },
    {
      path: "/Service",
      component: Service,
      meta: {
        title: "住院清单"
      }
    },
    {
      path: "/GeneralList",
      component: GeneralList,
      meta: {
        title: "住院信息",
        // keepAlive: true // 需要缓存
      }
    },
    {
      path: "/PriceInquiry",
      component: PriceInquiry,
      meta: {
        title: "物价查询"
      }
    },
    {
      path: "/nucleicTest",
      component: nucleicTest,
      meta: {
        title: "核酸号源"
      }
    },
    {
      path: "/payment",
      component: payment,
      meta: {
        title: "支付"
      }
    },
    {
      path: "/questionnaire",
      component: questionnaire,
      meta: {
        title: "问卷列表"
      }
    },
    {
      path: "/questionnaireList",
      component: questionnaireList,
      meta: {
        title: "满意度调查"
      }
    },
    {
      path: "/countDown",
      component: countDown,
      meta: {
        title: "待支付"
      }
    },
    {
      path: "/outpatientDepartment",
      component: outpatientDepartment,
      meta: {
        title: "门诊缴费"
      }
    },
    {
      path: "/mySubscribe",
      component: mySubscribe,
      meta: {
        title: "我的预约",
        keepAlive: true // 需要缓存
      }
    },
    {
      path: "/paymentRecord",
      component: paymentRecord,
      meta: {
        title: "缴费记录",
        keepAlive: true // 需要缓存
      }
    },
    {
      path: "/paymentRecordDetails",
      component: paymentRecordDetails,
      meta: {
        title: "缴费详情"
      }
    },
    {
      path: "/Report",
      component: Report,
      meta: {
        title: "报告查询",
        keepAlive: true // 需要缓存
      }
    },
    {
      path: "/textReportetails",
      component: textReportetails,
      meta: {
        title: "检验报告"
      }
    },
    {
      path: "/screenReportetails",
      component: screenReportetails,
      meta: {
        title: "检查报告"
      }
    },
    {
      path: "/OutpatientDeposit",
      component: OutpatientDeposit,
      meta: {
        title: "住院押金充值"
      }
    },
    {
      path: "/Recharge",
      component: Recharge,
      meta: {
        title: "押金充值"
      }
    },
    {
      path: "/RechargeRecord",
      component: RechargeRecord,
      meta: {
        title: "充值记录"
      }
    },
    {
      path: "/gotogzh",
      component: gotogzh,
      meta: {
        title: "跳转"
      }
    },
    {
      path: "/appointmentVaccines",
      component: appointmentVaccines,
      meta: {
        title: "前往预约疫苗"
      }
    },
    // {
    //   path: "/hospitalRegister",
    //   component: HospitalRegister,
    //   meta: {
    //     keepAlive: true // 需要缓存
    //   }
    // },
    // {
    //   path: "/index",
    //   redirect: "/index/searchDocter",
    //   component: Index,
    //   children: [{
    //     path: "consultingRoom",
    //     component: ConsultingRoom
    //   },
    //   {
    //     path: "searchDocter",
    //     component: SearchDoctor
    //   },
    //   {
    //     path: "user",
    //     component: User,
    //   }]
    // },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js